import { useState, useCallback } from 'react';

export const getSlideAnnouncement = (
  template: string | undefined,
  start: number,
  end: number,
  total: number
) => {
  const defaultTemplate = 'Showing items {start} through {end} of {total}';

  const announcementTemplate = template?.trim() || defaultTemplate;

  return announcementTemplate
    .replace('{start}', String(start))
    .replace('{end}', String(end))
    .replace('{total}', String(total));
};

export const useSliderAccessibility = (slideDescriptions: Array<string>, getVisibleCount: Function) => {

  const [slideAnnouncement, setSlideAnnouncement] = useState('');
  const [slideDescription, setSlideDescription] = useState<string>(slideDescriptions.length ? slideDescriptions[0] : '');
  const [isSliderFocused, setIsSliderFocused] = useState<boolean>(false);
  
  const handleSlideChange = (swiper: any) => {
    const total = swiper.slides.length;
    const visibleCount = getVisibleCount();

    const start = swiper.activeIndex + 1;
    const end = Math.min(start + visibleCount - 1, total);

    setSlideAnnouncement(
      getSlideAnnouncement(
        undefined,
        start,
        end,
        total
      )
    );
    setSlideDescription(slideDescriptions[swiper.activeIndex]);
  };

  const handleSliderContainerFocus = useCallback(() => {
    setIsSliderFocused(true);
  }, []);

  const handleSliderContainerBlur = useCallback((event: React.FocusEvent<HTMLElement>) => {
    const nextFocusedElement = event.relatedTarget as Node | null;
    const container = event.currentTarget;

    if (nextFocusedElement) {
      if (container.contains(nextFocusedElement)) {
        return;
      }

      setIsSliderFocused(false);
      return;
    }

    // Defer blur handling because autoplay slide transitions can momentarily blur
    // before focus is restored within the carousel. Capture `container` synchronously
    // above since React nulls out the pooled event's currentTarget before this runs.
    requestAnimationFrame(() => {
      const activeElement = document.activeElement;
      if (!container || (activeElement && container.contains(activeElement))) {
        return;
      }

      setIsSliderFocused(false);
    });
  }, []);

  return {
    slideAnnouncement,
    slideDescription,
    isSliderFocused,
    handleSlideChange,
    handleSliderContainerFocus,
    handleSliderContainerBlur,
  }
}
